import { type DefaultTheme, styled } from 'styled-components';

import { mediaQueryFor } from '../../theme';

import type { ColumnGapType, GridCellProps, GridWrapperProps, RowGapType } from './types';

const getXGap = (theme: DefaultTheme, columnGap: ColumnGapType) => {
  if (columnGap) {
    const space = parseFloat(theme.space.component.x[columnGap]);
    if (space) {
      return `${space / 2}rem`;
    }
  }
  return 0;
};

const getYGap = (theme: DefaultTheme, rowGap: RowGapType) => {
  if (rowGap) {
    const space = parseFloat(theme.space.component.y[rowGap]);
    if (space) {
      return `${space / 2}rem`;
    }
  }
  return 0;
};

export const StyledWrapper = styled.div<GridWrapperProps>`
  display: flex;
  flex-wrap: wrap;
  ${({ alignItems }) => (alignItems ? `align-items: ${alignItems};` : null)}
  ${({ justifyContent }) => (justifyContent ? `justify-content: ${justifyContent};` : null)}
  margin: ${({ theme, columnGap, rowGap }) => `-${getYGap(theme, rowGap as any)} -${getXGap(theme, columnGap as any)}`};
  > * {
    padding: ${({ theme, columnGap, rowGap }) =>
      `${getYGap(theme, rowGap as any)} ${getXGap(theme, columnGap as any)}`};
  }
`;

const makeCellWidth = (ratio: number | undefined) => {
  if (!ratio) {
    return 'display: none;';
  }
  return `
    flex-basis: ${ratio * 100}%;
    width: ${ratio * 100}%;
  `;
};

export const StyledCell = styled.div<GridCellProps>`
  display: flex;
  flex-shrink: 1;
  box-sizing: border-box;

  ${mediaQueryFor('mobile')} {
    ${({ xs }) => makeCellWidth(xs)}
  }
  ${mediaQueryFor('tablet')} {
    ${({ xs, s }) => makeCellWidth(s ?? xs)}
  }
  ${mediaQueryFor('laptop')} {
    ${({ xs, s, m }) => makeCellWidth(m ?? s ?? xs)}
  }
  ${mediaQueryFor('desktop')} {
    ${({ xs, s, m, l }) => makeCellWidth(l ?? m ?? s ?? xs)}
  }

  > div {
    width: 100%;
  }
`;
